/* eslint-disable react/prop-types */
import { Box, Typography } from '@mui/material';
import invoicemanagement from '../../../Assets/AlertIcon/invoicemanagement.svg';

export const ApprovalPersonsInvoiceManagementModules = ({
  permissionNames,
  handleNavigation,
  invoicePermissionCount,
}) => {
  // Check if user has Approval Persons Invoice Management permission
  const hasApprovalPersonsInvoiceManagementAccess = permissionNames?.includes(
    'Approval Persons Invoice Management'
  );

  if (!hasApprovalPersonsInvoiceManagementAccess) {
    return null;
  }

  const title =
    typeof invoicePermissionCount === 'number' && invoicePermissionCount > 1
      ? 'Invoice Management - Approval Persons'
      : 'Invoice Management';

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        mt: '3%',
        p: '14px 16px',
        bgcolor: '#f8e8e9',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.08)',
        borderRadius: '16px',
        display: 'inline-flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: '10px',
        cursor: 'pointer',
        transition: 'all 0.3s cubic-bezier(.25,.8,.25,1)',
        '&:hover': {
          boxShadow: '0 8px 32px 0 rgba(61, 0, 102, 0.25), 0 1.5px 8px 0 rgba(0,0,0,0.10)',
          transform: 'scale(1.04) translateY(-2px)',
          bgcolor: 'linear-gradient(90deg, #f8fafc 0%, #e0e7ff 100%)',
          border: '1.5px solid rgb(185, 168, 212)',
          '& .MuiTypography-root': {
            background: 'linear-gradient(90deg, #a18cd1 0%,rgb(119, 190, 191) 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            color: 'transparent',
          },
        },
      }}
      onClick={() => handleNavigation('Approval Persons Invoice Management')}
    >
      <Box
        sx={{
          width: '100%',
          display: 'inline-flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <img src={invoicemanagement} />
          <Typography
            sx={{
              fontSize: '16px',
              fontFamily: 'Inter',
              fontWeight: 500,
              color: '#181818',
              wordWrap: 'break-word',
            }}
          >
            {title}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
